import { render, staticRenderFns } from "./FilterPopupComposition.vue?vue&type=template&id=2fa4e966"
import script from "./FilterPopupComposition.vue?vue&type=script&lang=js"
export * from "./FilterPopupComposition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports